// extracted by mini-css-extract-plugin
export default {"filters":"SearchFilters_filters__7hg8b","filter":"SearchFilters_filter__fMX67"};